import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SinglePlayerSettings.css";

const SinglePlayerSettings: React.FC = () => {
  const navigate = useNavigate();
  const [gameType, setGameType] = useState<"normal" | "sprint">("normal");

  const handleStartGame = () => {
    navigate("/single-player", { state: { gameType } });
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="single-player-settings-container">
      <div className="single-player-settings-content">
        <h1 className="single-player-settings-title">
          Single Player Game Configuration
        </h1>

        <div className="game-type-selection">
          <h2 className="section-title">Select Game Type</h2>
          <div className="game-type-options">
            <label className="game-type-option">
              <input
                type="radio"
                name="gameType"
                value="normal"
                checked={gameType === "normal"}
                onChange={() => setGameType("normal")}
              />
              <div className="game-type-info">
                <h3>Normal</h3>
                <p>Classic single player mode with level progression</p>
              </div>
            </label>
            <label className="game-type-option">
              <input
                type="radio"
                name="gameType"
                value="sprint"
                checked={gameType === "sprint"}
                onChange={() => setGameType("sprint")}
              />
              <div className="game-type-info">
                <h3>Sprint</h3>
                <p>5-minute time challenge mode</p>
              </div>
            </label>
          </div>
        </div>

        <div className="single-player-settings-actions">
          <button
            className="button-secondary"
            onClick={handleBack}
          >
            Back
          </button>
          <button
            className="button-primary"
            onClick={handleStartGame}
          >
            Start Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default SinglePlayerSettings;

